import {PointOfContactProps} from "@/interfaces/point-of-contact_types.ts";

export function DefaultProps(): PointOfContactProps {
    return {
        uuid: "",
        name: "",
        email: "",
        phone_number: "",
        assigned_client: {
            uuid: "",
            name: "",
        }
    }
}